<template>
  <div class="series-side-sheet" v-if="series" :style="seriesSideSheetStyles">
    <SeriesSideSheetHeader :series="series" />
    <SeriesSideSheetContent :series="series" />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters, mapActions } from 'vuex';
import SeriesSideSheetHeader from './components/series-side-sheet-header';
import SeriesSideSheetContent from './components/series-side-sheet-content';

export default defineComponent({
  name: 'SeriesSideSheet',

  /**
   * 属性
   */
  props: {},

  /**
   * 数据
   */
  data() {
    return {};
  },

  /**
   * 监视
   */
  watch: {
    $route(newValue) {
      if (newValue.name === 'postShow') {
        this.getPostById(newValue.params.postId);
      }
    },
  },

  /**
   * 计算属性
   */
  computed: {
    ...mapGetters({
      sideSheetProps: 'layout/sideSheetProps',
      series: 'series/show/series',
    }),

    seriesSideSheetStyles() {
      return {
        '--series-color': this.series.color,
      };
    },
  },

  /**
   * 已创建
   */
  async created() {
    this.getSeriesCache(this.sideSheetProps.post.series.id);
  },

  /**
   * 组件方法
   */
  methods: {
    ...mapActions({
      getSeriesCache: 'series/show/getSeriesCache',
      getPostById: 'post/show/getPostById',
    }),
  },

  /**
   * 使用组件
   */
  components: {
    SeriesSideSheetHeader,
    SeriesSideSheetContent,
  },
});
</script>

<style scoped>
@import './styles/series-side-sheet.css';
</style>
